import { Tooltip } from "components/tooltip/Tooltip";
import React from "react";
import _ from 'lodash';
import { TriangleAlert } from "lucide-react";
import { ICON_SIZE } from "components/common/constants";

export const WarningIcon = () => (<TriangleAlert size={ICON_SIZE.SMALL} style={{ color: "var(--ga-color-icon-warning)" }}/>);

export const WarningsTooltip = (props) => {
    const warningsBySource = _.groupBy(props.warnings, w => w.source);
    const content = Object.keys(warningsBySource).map((source) => {
        const warnings = warningsBySource[source];
        return (
            <div>
                <strong>{source}</strong>
                {warnings.map((warning, index) => {
                    return (<div key={index}>{warning.message}</div>);
                })}
            </div>
        )
    })

    // `place`/`type`/`effect` are dropped deliberately: they matched what the shared tooltip
    // instance already applies, and passing them here would opt this tooltip out of sharing.
    return <Tooltip id={props.id} content={() => content}/>;
};
